module.exports = __webpack_public_path__ + "static/media/tamaz.dac6f309.png";